import * as dtos from "@/models/dtos";

export class Permission {
  Name = "";
  Id = 0;

  constructor(permission: dtos.PermissionResponse) {
    this.Name = permission.name;

    this.Id = permission.id;
    permission;
  }
}
